// extracted by mini-css-extract-plugin
export default {"certifications":"Certifications_certifications__PzdqT","certifications__title":"Certifications_certifications__title__grQMR"};